import asicflow_logo from '../assets/img/logos/asicflow_logo.png'
import { Link,useNavigate} from 'react-router-dom'
import {api} from '../../api.js'
import { useState } from "react";


function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [rememberMe, setRememberMe] = useState(false);

  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setMsg(""); // clear previous messages

    if (!email || !password) {
      setMsg("❌ Please fill in both email and password.");
      return;
    }

    try {
      const res = await api.login({ email, password });
      const data = await res.json();

      if (res.ok) {
        localStorage.setItem("token", data.token);
        if (rememberMe) {
          localStorage.setItem("rememberMe", "true");
        }
        setMsg("✅ Login successful! Redirecting...");
        setTimeout(() => navigate("/"), 1500); // redirect to home after 1.5s
      } else {
        setMsg(`❌ ${data.error}`);
      }
    } catch (err) {
      console.error(err);
      setMsg("❌ Server error. Please try again later.");
    }
  };

  return (
    <section className="bg-secondary p-3 p-md-4 p-xl-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-9 col-lg-7 col-xl-6 col-xxl-5">
            <div className="card border border-light-subtle rounded-4">
              <div className="card-body p-3 p-md-4 p-xl-5">

                {/* Message Display Area */}
                {msg && (
                  <div
                    className={`alert ${
                      msg.startsWith("✅") ? "alert-success" : "alert-danger"
                    } alert-dismissible fade show`}
                    role="alert"
                  >
                    {msg}
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setMsg("")}
                      aria-label="Close"
                    ></button>
                  </div>
                )}

                <div className="text-center mb-4">
                  <Link to="/">
                    <img src={asicflow_logo} alt="AsicFlow Logo" width={300} />
                  </Link>
                </div>

                <h4 className="text-center mb-4">
                  Welcome back, you've been missed!
                </h4>

                <form>
                  <div className="row gy-3">
                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="name@example.com"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        <label htmlFor="email">Email</label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="password"
                          className="form-control"
                          id="password"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />
                        <label htmlFor="password">Password</label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="remember_me"
                          checked={rememberMe}
                          onChange={(e) => setRememberMe(e.target.checked)}
                        />
                        <label
                          className="form-check-label text-secondary"
                          htmlFor="remember_me"
                        >
                          Keep me logged in
                        </label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="d-grid">
                        <button className="btn btn-primary btn-lg" type="button" onClick={submit}>
                          Log in now
                        </button>
                      </div>
                    </div>
                  </div>
                </form>

                <hr className="mt-5 mb-4 border-secondary-subtle" />
                <div className="d-flex gap-2 gap-md-4 flex-column flex-md-row justify-content-md-end">
                  <Link to="/signup" className="link-secondary text-decoration-none">
                    Create new account
                  </Link>
                  <Link
                    to="/passwordreset"
                    className="link-secondary text-decoration-none"
                  >
                    Forgot password
                  </Link>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
